import { get } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import useGetSharedData from './useGetSharedData';
import { Provider, createStore } from 'jotai';
import { useDispatch } from 'react-redux';
import { changeIsSharingPage } from '@store/common/actions';
import { setCurrentActiveDashboard } from '@src/store/tempDashboard/actions';
import { useResetForPreset } from '@src/hooks/useResetForPreset';

// HoC wrapper to apply shared data on the page state
function ShareHoc({ match, children, applyCallback, initStore = createStore }) {
  const id = `${get(match, 'params.id', '')}`;
  const { ready, refetch, data } = useGetSharedData({ id, applyCallback });

  const dispatch = useDispatch();

  useEffect(() => {
    refetch();
    // TODO: review and cleanup
    // for compatibility with current workflow
    // we can remove this after migrating all pages to new share
    dispatch(changeIsSharingPage(true));
    return () => {
      dispatch(changeIsSharingPage(false));
    };
  }, []);

  useResetForPreset();

  // intialize jotai store with default state
  const store = useMemo(() => {
    if (ready) {
      const rawState: any = get(data, 'state', '{}');
      const state = JSON.parse(rawState);
      dispatch(setCurrentActiveDashboard({ ...data, state }));
      return initStore(state);
    }
    return null;
  }, [data, ready, initStore]);

  return ready ? children({ store }) : <>Loading...</>;
}

export default ShareHoc;
